/// <reference path="Main.js" />
/// <reference path="utils.js" />
/// <reference path="Enumeration-vsdoc.js" />

/* global ajaxHelper */

window.JJK = window.JJK || {};

JJK.ZustellerBewerbung = function (formZustellerBewerbung, fahrzeugArten, verteilschemataErmittelnUrl, verteilschemataBeiBewerbungVorausgewaehlt) {
	this.formZustellerBewerbung = formZustellerBewerbung;
	this.fahrzeugArten = fahrzeugArten;
	this.VerteilschemataErmittelnURL = verteilschemataErmittelnUrl;
	this.verteilschemata = [];
	this.gewaehlteTage = [];
	this.verteilschemaLogosHtml = '';
	this.letzteWertGewaehlteTage = [];
	this.verteilschemataBeiBewerbungVorausgewaehlt = verteilschemataBeiBewerbungVorausgewaehlt;
	this.Init();
};

JJK.ZustellerBewerbung.prototype = {
	Init: function () {
		const self = this;

		$('#Strasse').on('blur', function () {
			self.GetInformation();
		});
		$('#Hausnummer').on('blur', function () {
			self.GetInformation();
		});
		$('#PLZ').on('blur', function () {
			self.GetInformation();
		});
		$('#Ort').on('blur', function () {
			self.GetInformation();
		});
		$('input[id^="GewaehlteTage."]').on('change', function () {
			self.GetInformation();
		});

		self.LoadDateFormat();
		window.set_before_submit(self.formZustellerBewerbung, self.bewerberdaten_before_submit);
		self.GetInformation();
		jjk.scrolleZuErstemFehlerhaftenFeld();
	},

	GetInformation: function () {
		const self = this;
		const strasse = $('#Strasse').val();
		const hsNr = $('#Hausnummer').val();
		const plz = $('#PLZ').val();
		const ort = $('#Ort').val();
		const bezirkNr = $('#BezirkNr').val();

		self.gewaehlteTage = [];
		$('input[id^="GewaehlteTage."]:checked').each(function () {
			self.gewaehlteTage.push(this.name.replace('GewaehlteTage.', ''));
		});

		if (bezirkNr != null) {
			if ($('#GewaehlteVerteilschemata').val() != null) {
				this.GetVerteilschemata(null, null, null, null, bezirkNr);
			}
		} else {
			if (
				strasse !== this.letzterWertStrasse ||
				hsNr !== this.letzterWertHsNr ||
				plz !== this.letzterWertPLZ ||
				ort !== this.letzterWertOrt ||
				JSON.stringify(this.gewaehlteTage) !== JSON.stringify(this.letzteWertGewaehlteTage)
			) {
				this.setzeWerte(strasse, hsNr, plz, ort, this.gewaehlteTage);
				if (strasse !== '' && hsNr !== '' && plz !== '' && ort !== '') {
					this.GetVerteilschemata(strasse, hsNr, plz, ort, bezirkNr);
				} else if (strasse === '' || hsNr === '' || plz === '' || ort === '') {
					this.SetzeVerteilschemaLogos('');
				}
			}
		}
	},

	setzeWerte: function (strasse, hsNr, plz, ort, tage) {
		this.letzterWertStrasse = strasse;
		this.letzterWertHsNr = hsNr;
		this.letzterWertPLZ = plz;
		this.letzterWertOrt = ort;
		this.letzteWertGewaehlteTage = tage;
	},

	LoadDateFormat: function () {
		$('#Geburtsdatum').datepicker({
			dateFormat: 'dd.mm.yy',
			showMonthAfterYear: true,
			changeYear: true,
			changeMonth: true,
			yearRange: '-100:+0',
			minDate: new Date(new Date().getFullYear() - 100, 1 - 1, 1),
			maxDate: '-13Y',
		});
		let textboxHelper = new JJK.TextBoxHelper();
		textboxHelper.LabelInTextbox('#Geburtsdatum', '#GeburtsdatumSpan');
		$.datepicker.setDefaults($.datepicker.regional['de']);
	},

	GetVerteilschemata: function (strasse, hsNr, plz, ort, bezirkNr) {
		const self = this;
		ajaxHelper.nurEinRequest(
			self.VerteilschemataErmittelnURL,
			{ strasse: strasse, hsNr: hsNr, plz: plz, ort: ort, gewahlteTage: self.gewaehlteTage.join(','), bezirkNummer: bezirkNr },
			function (data) {
				if (data.Verteilschemata.length >= 1) {
					self.SetzeVerteilschemaLogos(data.VerteilschemaLogosHtml);
					if (self.verteilschemataBeiBewerbungVorausgewaehlt) {
						self.verteilschemata = data.Verteilschemata.map(v => v.Id.toString());
						$('#GewaehlteVerteilschemata').val(self.verteilschemata.join(','));
					}
					$('#ZeitungWaehlen').show();
				} else {
					$('#ZeitungWaehlen').hide();
					self.SetzeVerteilschemaLogos('');
				}
			}
		);
	},

	SetzeVerteilschemaLogos: function (verteilschemaLogosHtml) {
		const self = this;
		if (this.verteilschemaLogosHtml !== verteilschemaLogosHtml) {
			this.verteilschemaLogosHtml = verteilschemaLogosHtml;
			$('#VerteilschemaLogos').html(verteilschemaLogosHtml);
			$('[name="VerteilschemaLogo"]').on('click', function () {
				self.SetVerteilschema(this);
			});
			if (convert2BootstrapCheckboxOrRadiobutton_geladen()) {
				$('#ZeitungWaehlen').addClass('d-block mb-3 w-100');
				$('#VerteilschemaLogos').find('br').remove();
				$('#VerteilschemaLogos')
					.find(':radio, :checkbox')
					.each(function () {
						convert2BootstrapCheckboxOrRadiobutton(this);
					});
			}
			return true;
		}
		return false;
	},

	SetVerteilschema: function (checkbox) {
		if (checkbox.checked) {
			this.verteilschemata.push(checkbox.value);
		} else {
			const index = this.verteilschemata.indexOf(checkbox.value);
			if (index > -1) {
				this.verteilschemata.splice(index, 1);
			}
		}
		$('#GewaehlteVerteilschemata').val(this.verteilschemata.join(','));
	},

	bewerberdaten_before_submit: function () {
		function removeIllegalChars(selector) {
			let newVal = $(selector).val();
			if (newVal === undefined) {
				return;
			}
			newVal = newVal.replace(/"|'|´|`/g, '');
			newVal = newVal.replace(/^\s*/, '');
			newVal = newVal.replace(/\s*$/, '');
			newVal = newVal.replace(/\s+/g, ' ');
			$(selector).val(newVal);
		}

		$('input[type=text]').each(function () {
			removeIllegalChars(this);
		});

		return false;
	},
};
